import { CustomActionWithPayload, SortDirection } from '@indigo-ag/component-module';
import { AgFinancingDocumentType } from '@indigo-ag/schema';

export enum TABLE_ACTIONS {
  NEXT_PAGE = 'NEXT_PAGE',
  PREVIOUS_PAGE = 'PREVIOUS_PAGE',
  SORT_CHANGED = 'SORT_CHANGED',
  ROW_SELECTED = 'ROW_SELECTED',
  ROW_DESELECTED = 'ROW_DESELECTED',
  ROW_SELECTION_CHANGED = 'ROW_SELECTION_CHANGED',
  ALL_ROWS_DESELECTED = 'ALL_ROWS_DESELECTED',
  ROW_EXPANDED = 'ROW_EXPANDED',
  ROW_COLLAPSED = 'ROW_COLLAPSED',
  REMOVE_NEGOTIATION = 'REMOVE_NEGOTIATION',
  UPDATE_CREDIT_ANALYST = 'UPDATE_CREDIT_ANALYST',
  REMOVE_DOCUMENT_TO_UPLOAD = 'REMOVE_DOCUMENT_TO_UPLOAD',
  SET_DOCUMENT_TO_UPLOAD_TYPE = 'SET_DOCUMENT_TO_UPLOAD_TYPE'
}

export type AgFinanceQueueCustomActions =
  | CustomActionWithPayload<TABLE_ACTIONS.SORT_CHANGED, TableSort>
  | CustomActionWithPayload<TABLE_ACTIONS.UPDATE_CREDIT_ANALYST, UpdateCreditAnalystPayload>;

export interface UpdateCreditAnalystPayload {
  userId: string | null;
  agFinancingId: string;
}

export interface TableSort {
  id: string;
  direction: SortDirection;
}

export interface SetDocumentToUploadTypePayload {
  id: string;
  documentType: AgFinancingDocumentType | null;
}

export type UploadDocumentsCustomActions =
  | CustomActionWithPayload<TABLE_ACTIONS.REMOVE_DOCUMENT_TO_UPLOAD, string>
  | CustomActionWithPayload<TABLE_ACTIONS.SET_DOCUMENT_TO_UPLOAD_TYPE, SetDocumentToUploadTypePayload>;
